import {
  createFormHookContexts,
  AnyFieldApi,
  AnyFormState,
} from "@tanstack/react-form";

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export const setFieldError = (field: AnyFieldApi, error: string) => {
  field.setMeta((prev) => ({
    ...prev,
    errorMap: {
      ...prev.errorMap,
      onSubmit: [prev.errorMap.onSubmit ?? null, error]
        .filter((e) => e)
        .join(", "),
    },
  }));
};

const displayFormFieldErrors = (fieldState: AnyFieldApi["state"]) => {
  const errors = Object.values(fieldState.meta.errorMap).filter(Boolean);
  return errors.length > 0 ? errors.join(", ") : undefined;
};

export const displayFormErrors = (formState: AnyFormState) => {
  return Object.values(formState.errorMap).length > 0
    ? Object.values(formState.errorMap).join(", ")
    : undefined;
};

export default displayFormFieldErrors;
